import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { getOrderDetails } from '../../helpers/api/cart';
import phone from '../../assets/images/phone.png';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;

  @media (max-width: 850px) {
    padding: 20px;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding: 40px 20px 40px 20px;
  background-color: #fff;
  max-width: 1024px;

  h1 {
    color: #f1a846;
    font-size: 34px;

    @media (max-width: 850px) {
      font-size: 24px;
    }
  }

  span {
    font-size: 15px;
    color: #888;
    margin-top: 20px;
  }

  img {
    @media (max-width: 850px) {
      width: auto;
      height: 30px;
      object-fit: contain;
    }
  }
`;

function Step4({ orderId, clearCart }) {
  // const { visaId, ppsId, fpsId } = onlinePaymentIds;
  const [orderDetails, setOrderDetails] = useState({});

  // console.log(orderId);
  // console.log(orderDetails);
  // console.log(paymentMethodId);

  useEffect(() => {
    getOrderDetails(orderId || localStorage.getItem('spareOrderId'))
      .then((response) => {
        setOrderDetails(response.data);
        clearCart();
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <Container>
      <MasterCardPayment orderDetails={orderDetails} />
    </Container>
  );
}

export default Step4;

const MasterCardPayment = ({ orderDetails }) => {
  const { t } = useTranslation();
  return (
    <Inner>
      <h1>
        {t('IhourlyCart.SuccessNumber')}
        {'   '}
        {orderDetails.reference}
      </h1>
      <span>{t('IhourlyCart.sevenSuccess')}</span>
      <span>
        {t('Cart.pleasePress')}
        <img src={phone} alt="" style={{ margin: '0px 5px' }} />
        {t('Cart.atTheEntry')}
      </span>
    </Inner>
  );
};

// const PpsPayment = () => (
//   <div
//     style={{
//       ...commonStyle.contentContainer,
//       width: '100%',
//       maxWidth: '100%',
//       background: '#fff',
//       paddingTop: 30,
//       paddingBottom: 30,
//     }}
//   >
//     <p>Pay by PPS status: Successful</p>
//   </div>
// );

// const FpsPayment = () => (
//   <div
//     style={{
//       ...commonStyle.contentContainer,
//       width: '100%',
//       maxWidth: '100%',
//       background: '#fff',
//       paddingTop: 30,
//       paddingBottom: 30,
//     }}
//   >
//     <h5>Booking Successful</h5>

//     <h5>Your reference number is: 1534347</h5>

//     <img style={{ marginBottom: 20, marginTop: 30 }} src={qrCode} width="15%" alt="qr_code" />
//   </div>
// );
